import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const convertHtmlToPdf = async (htmlContent: string): Promise<Blob> => {
  // Crear un contenedor temporal para el HTML
  const tempContainer = document.createElement('div');
  tempContainer.innerHTML = htmlContent;
  tempContainer.style.position = 'absolute';
  tempContainer.style.left = '-9999px';
  tempContainer.style.top = '0';
  tempContainer.style.width = '800px';
  document.body.appendChild(tempContainer);

  try {
    // Obtener el alto real del contenido
    const contentHeight = tempContainer.scrollHeight;
    // Convertir HTML a canvas
    const canvas = await html2canvas(tempContainer, {
      backgroundColor: '#fff', // Fondo blanco
      useCORS: true,
      allowTaint: true,
      scale: 2,
      width: 800,
      height: contentHeight, // Alto dinámico
    });

    // Convertir canvas a PDF
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');

    const imgWidth = 210; // Ancho A4 en mm
    const pageHeight = 295; // Alto A4 en mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;

    let position = 0;

    // Agregar primera página
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Agregar páginas adicionales si es necesario
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // Convertir PDF a Blob
    const pdfBlob = pdf.output('blob');
    return pdfBlob;
  } finally {
    // Limpiar el contenedor temporal
    document.body.removeChild(tempContainer);
  }
};
